import { gql } from "@apollo/client";

export const ADD_ORDERS_TO_CONSOLIDATION = gql`
    mutation AddOrdersToConsolidation($input: AddOrdersToConsolidationTypeInput!) {
        addOrdersToConsolidation(input: $input) {
            newBags {
                bagId
                bagNumber
                bagCode
                actualParcelCount
            }
            results {
                totalCount
                successCount
                failedCount
                failedTrackingNumbers
            }
            message
        }
    }
`;

export interface AddOrdersToConsolidationVariables {
    input: {
        warehouseId: string;
        taskId: string;
        trackingNumbers: string[];
    };
}

export interface AddOrdersToConsolidationResponse {
    addOrdersToConsolidation: {
        newBags: Array<{
            bagId: string;
            bagNumber: string;
            bagCode: string;
            actualParcelCount: number;
        }>;
        results: {
            totalCount: number;
            successCount: number;
            failedCount: number;
            failedTrackingNumbers: string[];
        };
        message?: string;
    };
} 